import React, { useEffect, useState } from "react";
import { Divider, Modal, Space, Typography } from "antd";
import { IoClose } from "react-icons/io5";
import SearchInput from "../Forms/SearchInput";
import DataTable from "../Tables/Datatable";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import PrimaryButton from "../Forms/PrimaryButton";
import { useSelector } from "react-redux";
import { useApiCall } from "../../services/api";

const { Title } = Typography;

export default function BookCaseModal({
  open,
  onClose,
  handleSubmit,
  title = "Book Cases",
  short_name = "",
  no_of_cases,
  loadingProp,
}) {
  const {postApi} = useApiCall();
  const { showPopup } = useGlobalModal();
  const [allClient, setAllClient] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const { user_id, is_sales_person } = useSelector((state) => state.auth);

  const [filteredClient, setFilteredClient] = useState([]);

  // Fetch clients from API
  const fetchClient = async () => {
    const payload = {
      ...(is_sales_person && { user_id }),
    };

    try {
      const response = await postApi("sales/assign-customer-list", payload);
      const formattedRows = (response.data || []).map((item, index) => ({
        ...item,
        key: index + 1,
      }));
      setAllClient(formattedRows);
      setFilteredClient(formattedRows);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => fetchClient(), 300);
    return () => clearTimeout(handler);
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = allClient.filter((c) => c.company_name?.toLowerCase().includes(value));
    setFilteredClient(filtered);
  };

  // Table columns
  const columns = [
    {
      title: "#",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Client Name",
      dataIndex: "company_name",
      key: "company_name",
    },
  ];

  return (
    <Modal className="form-css-2" open={open} footer={null} onCancel={onClose}>
      {/* Header */}
      <div className="flex justify-between items-center">
        <Title level={2} className="text-lg font-semibold text-black m-0 font-abhaya">
          {title}
        </Title>
      </div>

      {/* Details */}
      <div className="text-left">
        <h2 className="text-xl font-semibold text-gray-800">{short_name}</h2>
        <p className="text-gray-500 text-sm pb-2">No. of Cases - {no_of_cases}</p>
      </div>

      {/* Search */}
      <div className="flex w-full justify-between items-center">
        <SearchInput
          className="w-full"
          value={searchText}
          onChange={handleSearchChange}
          placeholder="Search for clients"
        />
      </div>

      {/* Table */}
      {/* <div className="flex-1 overflow-auto mt-2">
        <DataTable
          columns={columns}
          data={filteredClient}
          handleRow={(record) => {
            setSelectedRowKey(record.key);
            setSelectedRowData(record);
          }}
          Showpagination={false}
          className="table-bg-transparent"
        />
      </div> */}

      {/* Table */}
      <div className="mt-6 space-y-3">
        <div className="w-full px-4 text-left flex">
          <span className="w-[25%] text-left font-medium text-gray-700">#</span>
          <span className="text-gray-900 text-left w-[75%]">Client Name</span>
        </div>
        <Divider />
        {filteredClient?.map((item, i) => {
          const isSelected = selectedRowKey === item.key;
          return (
            <div
              key={i}
              onClick={() => {
                setSelectedRowKey(item.key);
                setSelectedRowData(item);
              }}
              className={`flex justify-between items-center px-4 py-2 cursor-pointer hover:bg-[#FBEEEC] hover:font-semibold rounded-md ${
                isSelected ? "bg-[#FBEEEC]" : "bg-transparent"
              }`}
            >
              <div className="w-full text-left flex justify-between">
                <span className="font-medium text-gray-700">{i + 1}</span>
                <span className="text-gray-900 text-left w-1/2">{item.company_name}</span>
                <span></span>
              </div>
            </div>
          );
        })}
        {filteredClient?.length === 0 && (
          <div className="py-2 text-center text-gray-500">Sorry, no clients found</div>
        )}
      </div>

      {/* Footer */}
      <div className="w-full mt-4 flex justify-center">
        <PrimaryButton
          text="Proceed"
          className="me-[30px]"
          onClick={() => {
            if (!selectedRowData) {
              showPopup({
                title: null,
                content: <span className="custom-modal-title">Please select a client.</span>,
                onOk: () => console.log("Confirmed!"),
                className: "custom-success-modal",
              });
              return;
            }
            handleSubmit(selectedRowData);
          }}
          loading={loadingProp}
        />
      </div>
    </Modal>
  );
}
